<template>
  <nav class="ocr-report-table-nav" aria-label="Report tables">
    <p class="ocr-report-table-nav-title">Tables</p>
    <div v-if="typeItems.length > 2" class="ocr-field ocr-report-table-nav-filter">
      <label class="profile-menu-label">Type</label>
      <v-select
        v-model="typeFilter"
        :items="typeItems"
        :menu-props="{ contentClass: 'ocr-select-menu' }"
        density="compact"
        variant="outlined"
        hide-details
      />
    </div>
    <p v-if="!visibleTables.length" class="ocr-report-table-nav-empty">No tables in report.</p>
    <ul v-else class="ocr-report-table-nav-list" role="list">
      <li
        v-for="t in visibleTables"
        :key="t.index"
        class="ocr-report-table-nav-item"
        :class="{ 'ocr-report-table-nav-item--active': t.index === modelValue }"
      >
        <button type="button" class="ocr-report-table-nav-btn" @click="$emit('update:modelValue', t.index)">
          <span class="ocr-report-table-nav-topline">
            <span class="ocr-report-table-nav-label">
              Pg {{ (t.page ?? 0) + 1 }} · Table {{ (t.page_table_number ?? t.table_number ?? t.index) }}
            </span>
            <span
              class="ocr-report-table-nav-chip"
              :class="t.status === 'mapped' ? 'ocr-report-table-nav-chip--ok' : 'ocr-report-table-nav-chip--todo'"
            >
              {{ t.status === "ignored" ? "Ignored" : t.status === "mapped" ? "Mapped" : "Review" }}
            </span>
          </span>
          <span class="ocr-report-table-nav-type">{{ t.table_type || "Unknown" }}</span>
        </button>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "OcrReportTableNav",
  props: {
    tables: { type: Array, default: () => [] },
    modelValue: { type: Number, default: null },
  },
  emits: ["update:modelValue"],
  data() {
    return { typeFilter: "All" };
  },
  computed: {
    typeItems() {
      const types = [...new Set(this.tables.map((t) => t.table_type || "Unknown"))].sort();
      return ["All", ...types];
    },
    visibleTables() {
      if (this.typeFilter === "All") return this.tables;
      return this.tables.filter((t) => (t.table_type || "Unknown") === this.typeFilter);
    },
  },
};
</script>
